import { render } from "./HeaderMobileMenuItem.vue?vue&type=template&id=4f5875ba&scoped=true"
import script from "./HeaderMobileMenuItem.vue?vue&type=script&lang=js"
export * from "./HeaderMobileMenuItem.vue?vue&type=script&lang=js"

import "./HeaderMobileMenuItem.vue?vue&type=style&index=0&id=4f5875ba&scoped=true&lang=css"

import exportComponent from "/builds/oleksandr.makhovskyi/admin-template/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f5875ba"]])

export default __exports__